import { Checkbox, FormControlLabel, FormGroup, styled } from '@mui/material';
import { ListDescription, ListFieldset, ListLabel } from '@shared/components/core/field/list/CommonListFieldStyles';
import DeviceTypeModel, { DeviceTypeFieldName } from '@shared/models/devices/DeviceTypeModel';
import OrganizationDeviceTypeModel from '@shared/models/organizations/OrganizationDeviceTypeModel';
import { useTranslation } from 'react-i18next';

export interface IDeviceTypeSupportsFeaturesEditorProps {
    editDeviceType: OrganizationDeviceTypeModel;
    onUpdate: <T extends DeviceTypeFieldName>(fieldName: T, value: DeviceTypeModel[T]) => void;
}

// List of specific fields to show checkboxes for
const specificBooleanFields: DeviceTypeFieldName[] = [
    'supportsVoiceInput',
    'supportsFaceInput',
    'supportsGestureInput',
    'supportsPhysicalInput',
    'supportsDigitalExtensions',
    'supportsPhysicalExtensions',
    'supportsKeyboardOutput',
    'supportsGenericControllerOutput',
    'supportsXboxControllerOutput',
    'supportsPlayStationControllerOutput',
    'supportsNintendoControllerOutput',
];

export default function DeviceTypeSupportFeaturesEditor({
    editDeviceType,
    onUpdate,
}: IDeviceTypeSupportsFeaturesEditorProps) {
    const { t } = useTranslation();
    return (
        <ListFieldset>
            <ListLabel as="legend">{t('common:organization.projects.deviceType.features.title')}</ListLabel>
            <ListDescription>{t('common:organization.projects.deviceType.features.description')}</ListDescription>
            <StyledFormGroup>
                {specificBooleanFields.map((fieldName) => (
                    <FormControlLabel
                        key={fieldName}
                        control={
                            <Checkbox
                                checked={!!editDeviceType[fieldName]}
                                onChange={(e) => onUpdate(fieldName, e.target.checked)}
                            />
                        }
                        label={t(`common:organization.projects.deviceType.features.${fieldName}`)}
                    />
                ))}
            </StyledFormGroup>
        </ListFieldset>
    );
}

const StyledFormGroup = styled(FormGroup)`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    width: 100%;
`;
